import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail, LayoutDashboard, Megaphone, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: Mail, title: "Check your email", body: "You'll receive an invite from Saving America Money to your private marketing dashboard — accept it to set your password and log in. Also look in spam/promotions just in case." },
  { icon: LayoutDashboard, title: "Log in to your dashboard", body: "Manage your listing, track leads, calendar bookings and forms all in one place inside your sub-account." },
  { icon: Megaphone, title: "Your ad goes live", body: "Your online directory ad is live or pending review. If you bought a postcard spot, our team adds your ad to the printable postcard proof for your ZIP shortly." },
];

export default function ThankYou() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-16" data-testid="thank-you-page">
      <div className="text-center">
        <CheckCircle2 className="h-14 w-14 text-sam-green mx-auto mb-4" />
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-sam-navy">Thank you for your business!</h1>
        <p className="text-sam-slate mt-4 text-base max-w-xl mx-auto">
          Welcome to Saving America Money. We're thrilled to help your business reach more hometown customers.
          Here's exactly what happens next.
        </p>
      </div>

      <div className="mt-10 space-y-4">
        {STEPS.map((s, i) => (
          <div key={s.title} className="flex gap-4 rounded-2xl border border-border bg-card p-5" data-testid={`thankyou-step-${i + 1}`}>
            <div className="shrink-0 h-10 w-10 rounded-full bg-sam-crimson/10 text-sam-crimson grid place-items-center font-display font-bold">{i + 1}</div>
            <div>
              <div className="flex items-center gap-2 font-display font-bold text-sam-navy"><s.icon className="h-4 w-4 text-sam-crimson" />{s.title}</div>
              <p className="text-sm text-sam-slate mt-1">{s.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap gap-3 justify-center">
        <Link to="/dashboard"><Button className="bg-sam-crimson hover:bg-sam-crimson/90" data-testid="thankyou-dashboard-btn">Go to my dashboard <ArrowRight className="h-4 w-4 ml-2" /></Button></Link>
        <Link to="/"><Button variant="outline" data-testid="thankyou-home-btn">Back to home</Button></Link>
      </div>

      <p className="text-center text-xs text-sam-slate mt-8">
        Questions? Email <a href="mailto:support@savingamericamoney.com" className="text-sam-crimson font-semibold">support@savingamericamoney.com</a> and we'll help you get set up.
      </p>
    </div>
  );
}
